import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["playlistIds", "values", "onChange", "isDisabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchDomains } from 'actions/domains';
import sortBy from 'utils/sortBy';
import DomainPickerModal from 'screens/DomainPickerModal';
import FormField, { useFormFieldContext } from 'components/FormField';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import TextLink from 'components/TextLink';
import SimpleListItem from 'components/SimpleListItem';
import ShadedCard from 'components/ShadedCard';
import Button from 'components/Button';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DomainCard(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/_jsx(ShadedCard, {
    px: "s",
    py: "xs",
    children: /*#__PURE__*/_jsx(SimpleListItem, {
      title: /*#__PURE__*/_jsx(TextLink, {
        href: "https://".concat(domain.subdomain),
        target: "_blank",
        children: domain.name || domain.subdomain
      }),
      subtitle: domain.subdomain
    })
  });
}
function useFormatDomainSelection(playlistIds) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _useFetchDomains = useFetchDomains({}),
    domains = _useFetchDomains.items;
  var subdomains = domains.map(function (domain) {
    return domain.subdomain;
  });
  var multiDomains = values.filter(function (_ref2) {
    var subdomain = _ref2.subdomain;
    return subdomains.includes(subdomain);
  }) || [];
  var domainMap = new Map();
  multiDomains.forEach(function (domain) {
    if (!domainMap.has(domain.id)) {
      domainMap.set(domain.id, _objectSpread(_objectSpread({}, domain), {}, {
        playlistIds: [domain.playlist_id]
      }));
    } else {
      domainMap.get(domain.id).playlistIds.push(domain.playlist_id);
    }
  });
  var selectedDomains = sortBy(Array.from(domainMap.values()), function (_ref3) {
    var name = _ref3.name;
    return name.toLowerCase();
  } // Order selection by name so they are displayed in same order as in the domain picker
  );
  var commonSelectedDomains = selectedDomains.filter(function (domain) {
    var _domain$playlistIds;
    return ((_domain$playlistIds = domain.playlistIds) === null || _domain$playlistIds === void 0 ? void 0 : _domain$playlistIds.length) === playlistIds.length;
  });
  var indeterminateSelectedDomains = selectedDomains.filter(function (domain) {
    var _domain$playlistIds2;
    return ((_domain$playlistIds2 = domain.playlistIds) === null || _domain$playlistIds2 === void 0 ? void 0 : _domain$playlistIds2.length) !== playlistIds.length;
  });
  return {
    allSelectedDomains: selectedDomains,
    commonSelectedDomains: commonSelectedDomains,
    indeterminateSelectedDomains: indeterminateSelectedDomains
  };
}
function DistributionField(_ref4) {
  var playlistIds = _ref4.playlistIds,
    _ref4$values = _ref4.values,
    values = _ref4$values === void 0 ? [] : _ref4$values,
    onChange = _ref4.onChange,
    isDisabled = _ref4.isDisabled,
    otherProps = _objectWithoutProperties(_ref4, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useFormatDomainSelec = useFormatDomainSelection(playlistIds, values),
    allSelectedDomains = _useFormatDomainSelec.allSelectedDomains,
    commonSelectedDomains = _useFormatDomainSelec.commonSelectedDomains,
    indeterminateSelectedDomains = _useFormatDomainSelec.indeterminateSelectedDomains;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasDistributionModal = _useState2[0],
    setHasDistributionModal = _useState2[1];
  var isMultiSelect = playlistIds.length > 1;
  var count = playlistIds.length;
  function handleSubmit(_ref5) {
    var toAdd = _ref5.toAdd,
      toRemove = _ref5.toRemove,
      selectedItems = _ref5.selectedItems;
    // Extra formatting to ensure we have correct entries for each selected playlist
    var toRemoveDomainIds = toRemove.map(function (item) {
      return item.id;
    });
    var toAddDomainIds = toAdd.map(function (item) {
      return item.id;
    });

    // Get the unchanged items for the selection
    var selected = values.filter(function (item) {
      return !toRemoveDomainIds.includes(item.id) && !toAddDomainIds.includes(item.id);
    });

    // Add the newly selected items to the selection
    if (toAdd.length > 0) {
      var selectedToAddForAll = selectedItems.filter(function (item) {
        return toAddDomainIds.includes(item.id);
      }).map(function (item) {
        return playlistIds.map(function (playlistId) {
          return _objectSpread(_objectSpread({}, item), {}, {
            playlist_id: Number(playlistId)
          });
        });
      }).flat();
      selected = [].concat(_toConsumableArray(selectedToAddForAll), _toConsumableArray(selected));
    }
    onChange({
      toAdd: toAdd,
      toRemove: toRemove,
      selectedItems: selected
    });
    setHasDistributionModal(false);
  }
  var commonListId = useUniqueId();
  var indeterminateListId = useUniqueId();
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_other_hubs')
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [!isMultiSelect && allSelectedDomains.length > 0 && /*#__PURE__*/_jsx(InlineList, {
        spacing: "s",
        "aria-labelledby": labelId,
        align: "top",
        children: allSelectedDomains.map(function (domain) {
          return /*#__PURE__*/_jsx(DomainCard, {
            domain: domain
          }, domain.subdomain);
        })
      }), isMultiSelect && commonSelectedDomains.length > 0 && /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        role: "group",
        "aria-labelledby": commonListId,
        children: [/*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Text, {
            id: commonListId,
            children: t('property_common')
          }), /*#__PURE__*/_jsx(HintTooltip, {
            content: t('hint_hub_playlist_common', {
              count: commonSelectedDomains.length
            }),
            spacingLeft: "xs",
            vAlign: false
          })]
        }), /*#__PURE__*/_jsx(InlineList, {
          spacing: "s",
          "aria-labelledby": labelId,
          align: "top",
          children: commonSelectedDomains.map(function (domain) {
            return /*#__PURE__*/_jsx(DomainCard, {
              domain: domain
            }, domain.subdomain);
          })
        })]
      }), isMultiSelect && indeterminateSelectedDomains.length > 0 && /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        role: "group",
        "aria-labelledby": indeterminateListId,
        children: [/*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Text, {
            id: indeterminateListId,
            children: t('property_individual')
          }), /*#__PURE__*/_jsx(HintTooltip, {
            content: t('hint_hub_playlist_individual', {
              count: indeterminateSelectedDomains.length
            }),
            spacingLeft: "xs",
            vAlign: false
          })]
        }), /*#__PURE__*/_jsx(InlineList, {
          spacing: "s",
          "aria-labelledby": labelId,
          align: "top",
          children: indeterminateSelectedDomains.map(function (domain) {
            return /*#__PURE__*/_jsx(DomainCard, {
              domain: domain
            }, domain.subdomain);
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        icon: "edit",
        isDisabled: isDisabled,
        onClick: function onClick() {
          return setHasDistributionModal(true);
        },
        size: "medium",
        children: t('actions_select_hubs')
      })]
    }), hasDistributionModal && /*#__PURE__*/_jsx(DomainPickerModal, {
      title: t('actions_distribute_playlist', {
        count: count
      }),
      defaultSelectedItems: commonSelectedDomains,
      defaultIndeterminateItems: indeterminateSelectedDomains,
      onSubmit: handleSubmit,
      onClose: function onClose() {
        return setHasDistributionModal(false);
      }
    })]
  }));
}
export default DistributionField;